import { Api } from 'core/api';

export const apiKeyApi = new Api({
  url: '/google-analytics/token',
});

export const fetchApiToken = apiKeyApi.fetch;
